import React from 'react';
import Footer from '../landing/footer/Footer';
import './support.scss';
const Support = () => {
    return (
        <>
            <section className="main-support ptb">
                <div className="container">
                    <div className="row">

                        <div className="col-sm-12">
                            <div className=" text-center">
                            <iframe sandbox="allow-scripts allow-popups allow-forms allow-same-origin" width="100%" height="660px"  src="https://forms.helpdesk.com?licenseID=1839285985&contactFormID=62aba420-2dab-48ee-a3c7-62c8f4c856e3">    Your browser does not allow embedded content.  </iframe>
                            </div>
                        </div>
                    </div>

                  
                </div>
            </section>
            <Footer/>
        </>
    )
}

export default Support;
